import Animation from "@/components/Animation";
import SubscriptionModal from "@/components/dashboard/MainDashPage/SubscriptionModal";
import { faq, plans } from "@/components/qashqool/LandingPageData";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { canRenewSubscription, isAssistant, isSubscriptionExpired } from "@/hooks/utils";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { pushModal } from "@/store/slices/modalsSlice";
import { CircleCheckBig, CircleX } from "lucide-react";

const SubscriptionPlans = () => {
  const dispatch = useAppDispatch();
  const { userProfileData } = useAppSelector((state) => state.store);
  return (
    <Animation>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            إختر الباقة المناسبة لك
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            اختر الخطة الأنسب لاحتياجاتك التعليمية. يمكنك تغيير الباقة في أي
            وقت.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => {
            const isSubscribed =
              userProfileData?.subscription_tier === plan.key &&
              !isSubscriptionExpired();
            return (
              <Card
                key={index}
                className={`relative ${
                  plan.popular ? "border-2 border-yellow-400 shadow-lg" : ""
                }`}
              >
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-yellow-400 text-yellow-900 px-4 py-1 rounded-full text-sm font-medium">
                      الأكثر مبيعاً
                    </span>
                  </div>
                )}

                <CardHeader className="text-center pb-2">
                  <div className="flex justify-center mb-4">{plan.icon}</div>
                  <CardTitle className="text-2xl font-bold">
                    {plan.title}
                  </CardTitle>
                  <div className="mt-4">
                    <span className="text-4xl font-bold">{plan.price}</span>
                  </div>
                </CardHeader>

                <CardContent className="space-y-6">
                  <div>
                    <h4 className="font-semibold text-primary mb-3">
                      المميزات
                    </h4>
                    <ul className="space-y-2">
                      {Object.keys(plan.features).map(
                        (feature, featureIndex) => (
                          <li
                            key={featureIndex}
                            className="flex items-start gap-2"
                          >
                            {plan.features[feature] ? (
                              <CircleCheckBig className="size-5 text-green-600" />
                            ) : (
                              <CircleX className="size-5 text-red-500" />
                            )}
                            <span className="text-sm">{feature}</span>
                          </li>
                        )
                      )}
                    </ul>
                  </div>

                  <Button
                    className="w-full"
                    variant="default"
                    disabled={isSubscribed || (isAssistant() && !canRenewSubscription())}
                    onClick={() =>
                      dispatch(pushModal(<SubscriptionModal tier={plan.key} />))
                    }
                  >
                    {plan.buttonText}
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 w-full">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            أسئلة شائعة
          </h2>
          <Accordion type="single" collapsible>
            {faq.map((q, index) => (
              <AccordionItem value={`item-${index + 1}`}>
                <AccordionTrigger className="text-lg">
                  {q.question}
                </AccordionTrigger>
                <AccordionContent className="text-base">
                  {q.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </Animation>
  );
};

export default SubscriptionPlans;
